import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Loader } from '../../../../shared/components/Loader';
import Box from '@mui/material/Box';
import { TabContext, TabList } from '@mui/lab';
import { Tab } from '@mui/material';
import * as Icon from '@mui/icons-material';
import { Button } from '../../../Styles/ScreenStyle';
import { TabDadosGerais } from './Components/TabDadosGerais';
import { TabCategoria } from './Components/TabCategoria';
import { TabCentrosCusto } from './Components/TabCentrosCusto';
import useContasPagar from '../../../../hooks/useContasPagarCadastrar';
import { useParams, useLocation } from 'react-router-dom';

const TABS = [
  {
    id: '1',
    label: 'Dados Gerais',
    icon: <Icon.InsertDriveFile />,
  },
  {
    id: '2',
    label: 'Categoria',
    icon: <Icon.Person />,
  },
  {
    id: '3',
    label: 'Centros de Custo',
    icon: <Icon.PersonOutline />,
  },
];

export default function ContasPagarCadastrar() {
  const { id } = useParams();
  const ContaPagarId = id ? parseInt(id) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  const {
    activeTab,
    handleTabChange,
    values,
    loading,
    errors,
    touched,
    handleAdicionar,
    handleChange,
    setFieldValue,
    handleAutoCompleteSelectedFornecedor,
    handleSearchFornecedor,
    fornecedorOptions,
    activeFornecedorSelected,
    handleAutoCompleteSelectedFormaPagamento,
    handleSearchFormaPagamento,
    formaPagamentoOptions,
    activeFormaPagamentoSelected,
    handleAutoCompleteSelectedCondicaoParcelamento,
    handleSearchCondicaoParcelamento,
    condicaoParcelamentoOptions,
    activeCondicaoParcelamentoSelected,
    handleAutoCompleteSelectedCategoria,
    handleSearchCategoria,
    categoriaOptions,
    activeCategoriaSelected,
    handleAutoCompleteSelectedCentroCusto,
    handleSearchCentroCusto,
    centroCustoOptions,
    activeCentroCustoSelected,
    single,
    handleCalculaParcelas,
  } = useContasPagar(ContaPagarId);

  return (
    <Loader loading={loading}>
      <HeaderComponent text={'DADOS DO TÍTULO A PAGAR'} />
      <Box className='py-3'>
        <Box className='grid grid-cols-8 gap-7 pt-4'>
          {/* <Box className='col-span-4 pt-1'>
            <UploadFile handleFileChange={handleFileChange} />
          </Box> */}
          <Box className='col-span-4'>
            <Button
              className={'!px-6'}
              onClick={() => history.back()}
              variant='contained'
              color='warning'
              startIcon={<Icon.Save />}
            >
              Voltar
            </Button>
            <Button
              //disabled={!saveXmlIsEnabled}
              className={'!px-6'}
              onClick={() => handleAdicionar()}
              variant='contained'
              color='success'
              startIcon={<Icon.Save />}
              disabled={duploClick}
            >
              Salvar
            </Button>
          </Box>
        </Box>
        <Box className={'pt-4'}>
          <TabContext value={activeTab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={handleTabChange}
                aria-label='lab API tabs example'
              >
                {TABS.map((item) => (
                  <Tab
                    key={item.id}
                    icon={item.icon}
                    label={item.label}
                    value={item.id}
                  />
                ))}
              </TabList>
            </Box>
            <TabDadosGerais
              values={values}
              handleChange={handleChange}
              errors={errors}
              touched={touched}
              setFieldValue={setFieldValue}
              handleAutoCompleteSelectedFornecedor={handleAutoCompleteSelectedFornecedor}
              handleSearchFornecedor={handleSearchFornecedor}
              FornecedorOptions={fornecedorOptions}
              activeFornecedorSelected={activeFornecedorSelected}
              handleAutoCompleteSelectedFormaPagamento={handleAutoCompleteSelectedFormaPagamento}
              handleSearchFormaPagamento={handleSearchFormaPagamento}
              FormaPagamentoOptions={formaPagamentoOptions}
              activeFormaPagamentoSelected={activeFormaPagamentoSelected}
              handleAutoCompleteSelectedCondicaoParcelamento={handleAutoCompleteSelectedCondicaoParcelamento}
              handleSearchCondicaoParcelamento={handleSearchCondicaoParcelamento}
              CondicaoParcelamentoOptions={condicaoParcelamentoOptions}
              activeCondicaoParcelamentoSelected={activeCondicaoParcelamentoSelected}   
              handleCalculaParcelas={handleCalculaParcelas}
              single={single}     
              duploClick={duploClick}   
            />
            <TabCategoria
              values={values}
              handleAutoCompleteSelectedCategoria={handleAutoCompleteSelectedCategoria}
              handleSearchCategoria={handleSearchCategoria}
              CategoriaOptions={categoriaOptions}
              activeCategoriaSelected={activeCategoriaSelected}  
              duploClick={duploClick}              
            />
            <TabCentrosCusto
              values={values}
              handleAutoCompleteSelectedCentroCusto={handleAutoCompleteSelectedCentroCusto}
              handleSearchCentroCusto={handleSearchCentroCusto}
              CentroCustoOptions={centroCustoOptions}
              activeCentroCustoSelected={activeCentroCustoSelected}
              duploClick={duploClick}   
            />
          </TabContext>
        </Box>
      </Box>
    </Loader>
  );
}